import { Component, Input } from '@angular/core';
import { MotButtonComponent } from '../mot-button.component';

@Component({
    selector: 'mot-loading-button',
    templateUrl: './mot-loading-button.component.html',
    styleUrls: ['./mot-loading-button.component.scss'],
    standalone: false
})
export class MotLoadingButtonComponent extends MotButtonComponent {
  @Input() isLoading: boolean;

}
